import React from 'react';
import { Scale, FileText, Users, Briefcase, AlertCircle, Building, Heart, Landmark, TrendingUp, FileCheck } from 'lucide-react';
import { mockData } from '../mockData';
import { Card, CardContent } from './ui/card';
import { scrollToSection } from '../lib/scroll';

const icons = [
  Scale,        // Direito Migratório
  AlertCircle,  // Direito Penal
  Briefcase,    // Direito Comercial
  Users,        // Direito do Trabalho
  FileText,     // Contraordenações
  Building,     // Registos e Notariado
  Heart,        // Direito da Família
  Landmark,     // Direito Administrativo
  TrendingUp,   // Recuperação de Créditos
  FileCheck     // Contratos
];

const ServiceCard = ({ service, Icon }) => (
  <Card className="group hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-gold/20 bg-white">
    <CardContent className="p-8 space-y-4">
      <div className="w-14 h-14 bg-gradient-to-br from-navy to-navy/80 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
        <Icon className="w-7 h-7 text-gold" />
      </div>

      <h3 className="font-serif text-xl font-bold text-navy group-hover:text-gold transition-colors duration-300">
        {service.title}
      </h3>

      <p className="text-navy/70 leading-relaxed">
        {service.description}
      </p>

      <div className="pt-4">
        <div className="h-1 w-0 bg-gold group-hover:w-full transition-all duration-500 rounded-full"></div>
      </div>
    </CardContent>
  </Card>
);

const ServicesCTA = () => (
  <div className="mt-16 text-center bg-navy rounded-lg p-12 relative overflow-hidden">
    <div className="absolute inset-0 opacity-5">
      <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v6h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
    </div>

    <div className="relative z-10 space-y-6">
      <h3 className="font-serif text-3xl md:text-4xl font-bold text-white">
        Não encontrou a área que procura?
      </h3>
      <p className="text-white/80 text-lg max-w-2xl mx-auto">
        Entre em contacto connosco. Teremos todo o gosto em analisar a sua situação e apresentar a melhor solução jurídica.
      </p>
      <button
        onClick={() => scrollToSection('contact')}
        data-testid="services-cta-button"
        className="bg-gold hover:bg-gold/90 text-navy font-semibold px-8 py-4 rounded-sm transition-all duration-300 hover:shadow-xl inline-block"
      >
        Contacte-nos Agora
      </button>
    </div>
  </div>
);

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-br from-cream via-white to-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <div className="inline-block">
            <span className="text-gold font-semibold text-sm uppercase tracking-wider">
              Áreas de Atuação
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-navy leading-tight">
            Experiência em
            <span className="text-gold"> Diversas Áreas do Direito</span>
          </h2>
          <p className="text-lg text-navy/70 leading-relaxed">
            Prestamos assessoria jurídica especializada a clientes particulares e empresariais,
            nacionais e estrangeiros, com soluções adaptadas a cada necessidade.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mockData.practiceAreas.map((service, index) => (
            <ServiceCard key={service.id} service={service} Icon={icons[index]} />
          ))}
        </div>

        <ServicesCTA />
      </div>
    </section>
  );
};

export default Services;
